export default "__VITE_ASSET__D56jR9LV__"